/**
 * USAGE CHECK ATOMS
 *
 * Stores results of "is this doc used elsewhere" checks
 * Used for validating deletes (e.g., can't delete class if students enrolled)
 */

import { atom } from "jotai"
import { atomFamily } from "jotai/utils"

import { DOC_TYPES } from "#customTypes/composedTypes/firebaseTypes"
import { Uuid } from "#customTypes/globalTypes"

// Key format: "docType:docId"
export const usageCheckResultAtom = atomFamily((key: string) => {
  const baseAtom = atom<boolean | null>(null)
  baseAtom.debugLabel = `usageCheck:${key}`
  return baseAtom
})

// Helper to create key
export const createUsageCheckKey = (
  docType: DOC_TYPES,
  id: Uuid | null | undefined
): string => {
  return `${docType}:${id ?? "null"}`
}
